import React from 'react';
import PropTypes from 'prop-types';
import { FormBuilder } from '../../../forms/form';
import withCustomInputHoc from '../custom-input-hoc';
import moment from 'moment';
import filter from 'lodash/filter';
import { DateInput } from './date-input';
import { TimeSelectorInput } from './time-selector-input';
import { TimeMap } from '../data/time-data';
import { injectIntl } from "react-intl";

const TimeSelectorInForm = withCustomInputHoc(TimeSelectorInput);
const DateSelectorInForm = withCustomInputHoc(DateInput);

class DateTimeForm extends React.Component {
  constructor (props) {
    super(props);
    this.inputRefs = {};
  }

  render () {
    const {
      startTimeIndex,
      endTimeIndex,
      selectedDate,
      isStartTimeOptional,
      isEndTimeOptional,
      formError,
      submitForm,
      submitFormCb,
      clearFilter,
      selectStartTime,
      selectEndTime,
      onDayClick,
      buttonText,
      defaultStartTimeIndex = 6,
      defaultEndTimeIndex = 22,
      intl
    } = this.props;
    const startTimes = filter(TimeMap, (value, key) => 35 >= key);
    const endTimes = filter(TimeMap, (time) => (startTimeIndex || defaultStartTimeIndex) < time.time_index);
    const timeInputs = [
      {
        custom:
          <div className={`col-md-6 ${this.props.dateColClass}`}>
            <DateSelectorInForm
              ref={ref => { this.inputRefs.date = ref; }}
              onDayClick={onDayClick}
              selectedDate={selectedDate}
              errorMessage={ intl.formatMessage({ id: 'shared_components.date_time_form.date_error', defaultMessage: 'Please enter a date' })}
              inputFieldName="dateInput"
              optional
            />
          </div>
      },
      {
        custom: () => (
          <div className="col-md-6 text-center">
          <h6 className="text-gray-dark search-by-date-header">{selectedDate ? intl.formatDate(selectedDate, {weekday: 'long', month: 'short', day: 'numeric' }) : ''}</h6>
          </div>
        )
      },
      {
        custom:
          <div className="time-group col-xs-6 col-md-3 no-gutter-right">
            <TimeSelectorInForm
              ref={ref => { this.inputRefs.startTime = ref; }}
              optional={isStartTimeOptional}
              htmlId="start-time"
              placeholder="start time"
              selectedTimeIndex={startTimeIndex || defaultStartTimeIndex}
              onChangeHandler={selectStartTime}
              errorMessage={ intl.formatMessage({ id: 'shared_components.date_time_form.start_error', defaultMessage: 'Please enter a start time' })}
              timeData={startTimes}
              inputFieldName="startTimeIndex"
              intl={intl}
            />
          </div>
      },
      {
        custom:
          <div className="time-group col-xs-6 col-md-3 no-gutter-left">
            <TimeSelectorInForm
              {...this.props}
              ref={ref => { this.inputRefs.endTime = ref; }}
              optional={isEndTimeOptional}
              htmlId="end-time"
              placeholder="end time"
              selectedTimeIndex={endTimeIndex || defaultEndTimeIndex}
              onChangeHandler={selectEndTime}
              errorMessage={ intl.formatMessage({ id: 'shared_components.date_time_form.end_error', defaultMessage: 'Please enter an end time' })}
              timeData={endTimes}
              inputFieldName="endTimeIndex"
              intl={intl}
            />
          </div>
      }
    ];
    return (
      <div className="DateTimeForm search-by-date dropdown-list" style={{ margin: '0 -1px' }}>
        <FormBuilder
          errorText={formError}
          inputRefs={this.inputRefs}
          formname="search-by-date-form"
          formStyle="standard"
          formInputs={timeInputs}
          submitAction={submitForm}
          submitCallback={submitFormCb}
          buttonText={buttonText || intl.formatMessage({ id: 'shared_components.date_time_form.apply', defaultMessage: 'Apply' })}
          btnColSize="form-btn-col col-xs-12"
          buttonClass="btn btn-lg btn-block btn-primary form"
          containerClass="form-btn-container"
          clearFilterFn={clearFilter}
        />
      </div>
    );
  }
}

exports.DateTimeForm = injectIntl(DateTimeForm);

DateTimeForm.propTypes = {
  startTimeIndex: PropTypes.string,
  endTimeIndex: PropTypes.string,
  selectedDate: PropTypes.object,
  isStartTimeOptional: PropTypes.bool,
  isEndTimeOptional: PropTypes.bool,
  formError: PropTypes.string,
  submitForm: PropTypes.func,
  submitFormCb: PropTypes.func,
  clearFilter: PropTypes.func,
  selectStartTime: PropTypes.func,
  selectEndTime: PropTypes.func,
  onDayClick: PropTypes.func,
  dateColClass: PropTypes.string,
  buttonText: PropTypes.string
};
